<!-- <<<<<<<<<<<<<<<<<<<<<<<<<<>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>-->
<!-- NOTE: See BasicInfoCardComponent.vue for simple use cases-->
<!-- <<<<<<<<<<<<<<<<<<<<<<<<<<>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>-->

<template>
  <!-- overflow-hidden clips the card-body background (e.g. bg-body-highlight) to the card's rounded corners -->
  <div class="card overflow-hidden" :class="containerClass">
    <div :class="cardBodyClass" class="card-body p-1 px-3 p-sm-2 px-sm-3">
      <div
        class="d-flex align-items-center"
        @click="clickArea === 'title' && toggleCollapse()"
        role="button"
      >
        <slot name="title"></slot>
        <div
          :class="['btn', buttonText ? 'btn-text' : 'btn-icon', 'p-2']"
          @click="clickArea === 'button' && toggleCollapse()"
        >
          <span v-if="buttonText">{{ buttonText }}</span>
          <FontAwesomeIcon v-else :icon="showCollapse ? 'minus' : 'plus'" />
        </div>
      </div>
      <div class="text-body-secondary mt-1" v-show="showCollapse">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

withDefaults(
  defineProps<{
    buttonText?: string;
    clickArea?: string;
    containerClass?: string;
    cardBodyClass?: string;
  }>(),
  {
    clickArea: "title",
    containerClass: "mt-sm-2",
    cardBodyClass: "bg-body-highlight",
  }
);

const emit = defineEmits<{
  setForceToggle: [forceToggleCollapse: (value: boolean) => void];
}>();

const showCollapse = ref(false);

const toggleCollapse = () => {
  showCollapse.value = !showCollapse.value;
};

const forceToggleCollapse = (value: boolean) => {
  showCollapse.value = value;
};

// Expose the method
emit("setForceToggle", forceToggleCollapse);
</script>
